export default "__VITE_ASSET__CGwMkEff__"